import { BlocksIconShare } from 'blocks-nextjs/blocks-web-components/components/icon/icons/share';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconShare = createComponent({ react: React, tagName: 'cat-icon-share', elementClass: BlocksIconShare });
